import React from 'react';
import {
  AreaChart,
  Area,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

// Custom Tooltip for Completed Scans
const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || !payload.length) return null;

  const data = payload[0]?.payload || {};

  return (
    <div className="bg-gray-900/95 backdrop-blur-sm px-2 py-1 rounded shadow-xl border border-emerald-500/30 text-xs">
      <p className="text-gray-400">{label}</p>
      <p className="font-medium text-emerald-400">{data.completed} / {data.total}</p>
      <p className="text-gray-500">{data.rate}%</p>
    </div>
  );
};

const CompletedMiniChart = ({ data }) => {
  // Default mock data for 7 days
  const defaultData = [
    { date: '24', completed: 4, pending: 1, rate: 80, total: 5 },
    { date: '25', completed: 7, pending: 1, rate: 87, total: 8 },
    { date: '26', completed: 6, pending: 0, rate: 100, total: 6 },
    { date: '27', completed: 8, pending: 2, rate: 80, total: 10 },
    { date: '28', completed: 6, pending: 1, rate: 86, total: 7 },
    { date: '29', completed: 9, pending: 0, rate: 100, total: 9 },
    { date: '30', completed: 5, pending: 0, rate: 100, total: 5 },
  ];

  const chartData = data || defaultData;

  return (
    <div className="w-full h-full">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={chartData}
          margin={{ top: 2, right: 2, bottom: 2, left: 2 }}
        >
          <defs>
            <linearGradient id="completedGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#10B981" stopOpacity={0.6} />
              <stop offset="50%" stopColor="#059669" stopOpacity={0.3} />
              <stop offset="100%" stopColor="#064E3B" stopOpacity={0.1} />
            </linearGradient>
          </defs>

          <Area
            type="monotone"
            dataKey="completed"
            stroke="#10B981"
            strokeWidth={1.5}
            fill="url(#completedGradient)"
            dot={false}
            activeDot={{
              r: 3,
              fill: '#10B981',
              stroke: '#000',
              strokeWidth: 1,
            }}
            animationDuration={600}
          />

          <Tooltip
            content={<CustomTooltip />}
            cursor={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CompletedMiniChart;
